import React, { useState, useEffect, useRef, Fragment } from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Row, Button, FormGroup, Label, Input, Alert, Modal, ModalHeader,
    ModalBody, ModalFooter, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import '../estilos.css';
import * as IoIcons from 'react-icons/io';
import Pagination from "react-js-pagination";
import Moment from 'moment';
//import { Amplify, API } from 'aws-amplify';
import {
    onCreatePlaneacionBase, onCreateResumenOperacion, onDeletePlaneacionBase, onDeleteRecibaSeriales,
    onDeleteResumenOperacion,
    onUpdatePlaneacionBase, onUpdateRecibaSeriales,
    onUpdateResumenOperacion
} from '../../graphql/subscriptions';
import * as xlsx from "xlsx";
import { useReactToPrint } from 'react-to-print';
import {
    GetResumenOperacion, GetUsuarios
} from '../queries/Queries';
import { decodificarInventarioCliente } from '../queries/DCUbicaciones';
import EditarRO from './EditarRO';
import { generateClient } from "aws-amplify/api";

const API = generateClient();



const initialfFormState = { formType: 'ResumenO' }
function ResumenOperacion() {

    const [encROPeracion, setEncROPeracion] = useState([]);
    const [datoFROperacion, setDatoFROperacion] = useState([]);
    const [dInventarioC, setDInventarioCn] = useState([]);
    const [rOperacionSinFiltro, setROperacionSinFiltro] = useState([]);
    const [rOperacion, setROperacion] = useState([]);
    const [editar, setEditar] = useState(false);
    const [formState, updateFormState] = useState(initialfFormState);
    const [buscarporFecha, setBuscarporFecha] = useState(true);
    const [fechaPBusqueda, setFechaPBusqueda] = useState("");
    const [totalRecords, setTotalRecords] = useState(0);
    const { formType } = formState;
    const [mensajeAlert, setMensajeAlert] = useState("No fue posible realizar la operación, error indeterminado: revise su conexión a internet, recargue la página y vuelva a intentarlo, si el error persiste, favor de comunicarse a sistemas");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const vroperacion = window.$ResumenOperacionVer ? window.$ResumenOperacionVer : false;
    const edoperacion = window.$ResumenOperacionEDefectos ? window.$ResumenOperacionEDefectos : false;
    const eploperacion = window.$ResumenOperacionEPLaboratorio ? window.$ResumenOperacionEPLaboratorio : false;
    const eauoperacion = window.$ResumenOperacionEAusentismoP ? window.$ResumenOperacionEAusentismoP : false;
    const edeoperacion = window.$ResumenOperacionEDatosExtra ? window.$ResumenOperacionEDatosExtra : false;
    const [aVisible, setAVisible] = useState(false);
    const [cargando, setCargando] = useState(false);
    const [fechaPlaneacionM, setFechaPlaneacionM] = useState("");
    const [sumProduccion, setSumProduccion] = useState("");
    const [vistaNumeroParte, setVistaNumeroParte] = useState(false);
    const [sumICiclos, setSumICiclos] = useState("");
    const [sumCostoTotal, setSumCostoTotal] = useState("");
    const onDismiss = () => setAVisible(false);
    const [inputList, setInputList] = useState([]);
    const [activeTab, setActiveTab] = useState('1');
    const [paginas, setPaginas] = useState([]);
    const [datosUsuario, setDatosUsuario] = useState([]);
    const [modal, setModal] = useState(false);
    const [precioUnitarioImp, setPrecioUnitarioIMP] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [sumPorcentajeT, setSumPorcentajeT] = useState(0);
    const [sumPorcentajeC, setSumPorcentajeC] = useState(0);
    //Se asignan los valores correspondientes a las claves 
    var resumenO = [{ campo: "Total Inspeccionado", clave: "totalInspeccionado", signo: "" },
    { campo: "Defectuoso BTI", clave: "defectuso", signo: "" },
    { campo: "% Defectuoso", clave: "porcentajeDefectuoso", signo: "%" },
    { campo: "1er contribuidor", clave: "primerContribuidor", signo: "" },
    { campo: "1er contribuidor NP", clave: "primerContribuidorNP", signo: "" },
    { campo: "2do Contribuidor", clave: "segundoContribuidor", signo: "" },
    { campo: "2do Contribuidor NP", clave: "segundoContribuidorNP", signo: "" },
    { campo: "3er Contribuidor", clave: "tercerContribuidor", signo: "" },
    { campo: "3er ContribuidorNP", clave: "tercerContribuidorNP", signo: "" },
    { campo: "SQFT Producidos", clave: "sqftProducidos", signo: "" },
    { campo: "Gasto quimicos", clave: "gastosQuimicos", signo: "$" },
    { campo: "Consumo de Agua", clave: "consumoAgua", signo: "" },
    { campo: "Costo Quimico SQFT", clave: "costoQuimicoSQFT", signo: "$" },
    { campo: "Costo Quimico vs Facturacion", clave: "costoQuimicovsFacturacion", signo: "$" },
    { campo: "Eficiencia de Carga de racks", clave: "eficienciaCargaRacks", signo: "%" },
    { campo: "Capacidad de Linea", clave: "ecCapacidadLinea", signo: "" },
    { campo: "Racks Programados", clave: "ecProgramados", signo: "" },
    { campo: "Capacidad de Linea Programada", clave: "ecCapacidadLineaProgramada", signo: "%" },
    { campo: "Racks Cargados", clave: "ecCargados", signo: "" },
    { campo: "Eficiencia de carga vs Plan de producción", clave: "ecEFvsPP", signo: "%" },
    { campo: "Espacios vacios", clave: "ecEspaciosVacios", signo: "" },
    { campo: "% Perdido", clave: "ecPorcentajePerdido", signo: "%" },
    { campo: "Falta de personal de carga Ecoat", clave: "apFaltaCarga", signo: "" },
    { campo: "Incapacidad de personal de Carga Ecoat", clave: "apIncapacidadCarga", signo: "" },
    { campo: "Falta de personal de Inspeccion Ecoat", clave: "apFaltaInspeccion", signo: "" },
    { campo: "Incapacidad de personal de Inspeccion Ecoat", clave: "apIncapacidadInspeccion", signo: "" },
    { campo: "Falta de personal de carga Powder", clave: "apFaltaCargaPC", signo: "" },
    { campo: "Incapacidad de personal de Carga Powder", clave: "apIncapacidadCargaPC", signo: "" },
    { campo: "Falta de personal de Inspeccion Powder", clave: "apFaltaInspeccionPC", signo: "" },
    { campo: "Incapacidad de personal de Inspeccion Powder", clave: "apIncapacidadInspeccionPC", signo: "" },
    { campo: "Objetivo de facturacion 2025", clave: "objetivoFacturacion", signo: "$" },
    { campo: "Meta de Venta para cumplimiento KPI", clave: "metaVentaCumplimientoKPI", signo: "$" },
    { campo: "Facturación planeada", clave: "facturacionPlaneada", signo: "$" },
    { campo: "Facturacion", clave: "facturacion", signo: "$" },
    { campo: "Facturado pendiente por embarcar", clave: "facturadoPendientePorEmbarcar", signo: "$" },
    { campo: "Facturacion total del día", clave: "facturacionTotaldelDia", signo: "$" },
    { campo: "Diferencia vs Planeado", clave: "diferenciaVSPlaneado", signo: "$" },
    { campo: "Diferencia %", clave: "diferenciaPorcentaje", signo: "%" },
    { campo: "Material pendiente por inspeccion", clave: "materialPendienteporInspeccion", signo: "$" },
    { campo: "Inventario", clave: "inventario", signo: "$" },
    { campo: "Estatus de pendientes y mejoras", clave: "estatusPendientesMejoras", signo: "" },
    { campo: "Acciones a tomar", clave: "accionesaTomar", signo: "" }]


    Moment.locale('en');
    var now = new Date();
    var now2 = new Date();
    var cincoDias = new Date();
    //now2.setMonth(now2.getMonth() - 1);
    now2.setDate(now2.getDate() - 1);
    now.setDate(now.getDate() + 5);
    const [rfechaini, setRfechaini] = useState(Moment(now2).format("YYYY-MM-DD"));
    const [rfechafin, setRfechafin] = useState(Moment(now).format("YYYY-MM-DD"));


    const toggle1 = tab => {
        if (activeTab !== tab) setActiveTab(tab);
        if (tab > 1) setAVisible(false);
    }

    const toggle = () => setModal(!modal);
    const toggle2 = () => setModal2(!modal2);

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    // current page
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPagePlaneacion, setCurrentPagePlaneacion] = useState(1);

    // total records per page to display
    const recordPerPage = 3;

    // range of pages in paginator
    const pageRange = 5;


    // handle change event
    function handlePageChange(pageNumber) {
        window.scrollTo(0, 0);
        setCargando(true);
        setAVisible(false);
        setCurrentPage(pageNumber);
        setCargando(false);
        fetchROperacion(rfechaini, rfechafin);
    }

    async function transponer(ROperacionSF) {
        //Se obtienen los campos de la tabla que serán la fecha del Resumen de operación
        //const campos = ROperacionSF.map(d => d.fecha);
        //Se obtienen las claves y sus valores de la tabla
        //Se obtienen los datos del inventarion
        var dincv = [...ROperacionSF];
        var diin = [];
        var clavesInv = [];
        const claves = Object.keys(dincv[0]).filter(k => k !== 'fecha' && k !== 'id' && k !== 'recibaSerialIDS'
            && k !== 'activo' && k !== 'Reg_Ins_Usuario' && k !== 'Reg_Mod_Usuario' && k !== 'inventarioOperacion'
            && k !== 'createdAt' && k !== '__typename' && k !== 'updatedAt' && k !== 'estatusPendientesMejoras' && k !== 'accionesaTomar'
        );

        const clavesUlt = Object.keys(dincv[0]).filter(k => k === 'estatusPendientesMejoras' || k === 'accionesaTomar');
        //"estatusPendientesMejoras", accionesaTomar"
        //Se obtienen los valores requeridos y se guardan en clavesInv 
        claves.map((clave, i) => (
            clavesInv.push({ clave: resumenO[i].campo, valores: ROperacionSF.map(d => d[clave]) })
        ));

        await Promise.all(dincv.map(async (rOperacion, i) => {
            //rOperacion.numero = pi;
            if (rOperacion.inventarioOperacion) {
                const datosInv = await decodificarInventarioCliente(rOperacion.inventarioOperacion, rOperacion.fecha);
                if (datosInv.inventarioClientes.length > 0) {
                    diin = [...diin, ...datosInv.inventarioClientes];
                    var datosinv = [];
                    await Promise.all(datosInv.inventarioClientes.map(async (datosinvc, i) => {
                        //Se verifica si el cliente ya existe en el arreglo
                        const cliente = datosinvc.cliente;
                        const clienteExistente = clavesInv.find(c => c.clave === cliente);
                        if (clienteExistente) {
                            //Si el cliente ya existe, se suma la cantidad de piezas
                            datosinv = [...clienteExistente.valores];
                            datosinv.push(datosinvc.total);
                            clienteExistente.valores = datosinv;
                        } else {//Si el cliente no existe, se agrega a los arreglos correspondientes
                            datosinv = [];
                            datosinv.push(datosinvc.total);
                            clavesInv.push({ //Se agregan todos los datos al arreglo de datos
                                clave: cliente,
                                valores: datosinv,
                            });
                        }
                    }))
                }
            }
            return dincv;
        }));
        //Se obtienen los valores requeridos y se guardan en clavesInv 
        clavesUlt.map((clave, i) => (
            clavesInv.push({
                clave: clave === "estatusPendientesMejoras" ? "Estatus de pendientes y mejoras" : clave === "accionesaTomar" ? "Acciones a tomar" : "",
                valores: ROperacionSF.map(d => d[clave])
            })
        ));
        /*clavesInv.push({ clave: "Prueba 1", valores: ["1", "2", "3"] })*/

        setDatoFROperacion(clavesInv);
        setROperacion(ROperacionSF);
        setDInventarioCn(diin);
        return clavesInv;
    };

    async function busquedaROperacion(ROperacionSF, currentPage) {
        try {
            //Se inicializan los valores de las variables
            setSumICiclos("");
            setSumProduccion("");
            setSumCostoTotal("");
            setROperacion([]);
            setEncROPeracion([]);
            setDatoFROperacion([]);
            setDInventarioCn([]);
            setPaginas([]);
            var paginasp = [];
            var encResumenO = [];
            var pi = 1;
            var bandera = 1;
            //Si existen rOperacion a mostrar          
            if (ROperacionSF.length > 0) {
                //Se filtran los datos por los parámetros establecidos
                ROperacionSF = ROperacionSF.sort((a, b) =>
                    (a.fecha) < (b.fecha) ? 1 : (a.fecha) > (b.fecha) ? -1 : 0);
                const datosROT = await transponer(ROperacionSF);
                await Promise.all(ROperacionSF.map(async (rOperacion, i) => {
                    bandera++;
                    if (bandera > recordPerPage) {
                        paginasp.push({ pagina: pi, });
                        bandera = 1;
                        pi++;
                    }
                    encResumenO.push({
                        fecha: rOperacion.fecha, id: rOperacion.id, defectuso: rOperacion.defectuso, totalInspeccionado: rOperacion.totalInspeccionado,
                        porcentajeDefectuoso: rOperacion.porcentajeDefectuoso, primerContribuidor: rOperacion.primerContribuidor,
                        primerContribuidorNP: rOperacion.primerContribuidorNP, segundoContribuidor: rOperacion.segundoContribuidor,
                        segundoContribuidorNP: rOperacion.segundoContribuidorNP, tercerContribuidor: rOperacion.tercerContribuidor,
                        tercerContribuidorNP: rOperacion.tercerContribuidorNP, sqftProducidos: rOperacion.sqftProducidos,
                        gastosQuimicos: rOperacion.gastosQuimicos, consumoAgua: rOperacion.consumoAgua,
                        costoQuimicoSQFT: rOperacion.costoQuimicoSQFT, costoQuimicovsFacturacion: rOperacion.costoQuimicovsFacturacion,
                        apFaltaCarga: rOperacion.apFaltaCarga, apIncapacidadCarga: rOperacion.apIncapacidadCarga,
                        apFaltaInspeccion: rOperacion.apFaltaInspeccion, apIncapacidadInspeccion: rOperacion.apIncapacidadInspeccion,
                        apFaltaCargaPC: rOperacion.apFaltaCargaPC, apIncapacidadCargaPC: rOperacion.apIncapacidadCargaPC,
                        apFaltaInspeccionPC: rOperacion.apFaltaInspeccionPC, apIncapacidadInspeccionPC: rOperacion.apIncapacidadInspeccionPC,
                        estatusPendientesMejoras: rOperacion.estatusPendientesMejoras, accionesaTomar: rOperacion.accionesaTomar
                    });
                    return rOperacion;
                }));

                const lengthrOperacion = ROperacionSF.length;
                if (lengthrOperacion <= 0) {
                    setCurrentPage(1);
                }
                setEncROPeracion(encResumenO);
                setTotalRecords(lengthrOperacion);

            }
            setCargando(false);
        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert("Error: " + JSON.stringify(e));
            setColor("warning");
            setAVisible(true);
            setCargando(false);
        }
    }
    useEffect(() => {
        //subscriptions();
        fetchROperacion(rfechaini, rfechafin);
        fetchUsuario();
        //return () => subscriptions.unsubscribe();
    }, []);

    //Función que crea las subscripciones
    function subscriptions() {
        //se suscriben para los cambios en planeación base
        // filtro en base a la fecha de planeación.
        const variables = {
            filter: {
                and: [{
                    activo: {
                        eq: true
                    }
                }]

            }
        };


        //Subscripciones de la planeación base
        API.graphql({ query: onUpdateResumenOperacion, variables }).subscribe({
            next: ({ provider, value }) => fetchROperacion(), //value.data.onUpdatePlaneacionBase
            error: (error) => console.warn(error)
        });

        API.graphql({ query: onCreateResumenOperacion, variables }).subscribe({
            next: ({ provider, value }) => fetchROperacion(), //value.data.onUpdatePlaneacionBase
            error: (error) => console.warn(error)
        });

        API.graphql({ query: onDeleteResumenOperacion, variables }).subscribe({
            next: ({ provider, value }) => fetchROperacion(), //value.data.onUpdatePlaneacionBase
            error: (error) => console.warn(error)
        });
    }


    //Obtiene los datos guardados de las   rOperacion
    async function fetchROperacion(fechainicial, fechafinal) {
        //Filtro por planeación activa
        window.scrollTo(0, 0);
        setCargando(true);
        setInputList([]);
        let filter = {
            and: [{
                activo: {
                    eq: true
                }
            },
            {
                fecha: {
                    ge: fechainicial ? fechainicial : rfechaini
                }
            },
            {
                fecha: {
                    le: fechafinal ? fechafinal : rfechafin
                }
            }]
        }

        //Se obtienen los datos de la planeación
        const apiData = await GetResumenOperacion(filter);

        //Se obtienen los datos de la planeación
        //const apiData = await GetPlaneacion(filter);
        const planeacionesFromAPI = apiData.sort((a, b) =>
            a.fecha < b.fecha ? 1 : a.fecha > b.fecha ? -1 : 0);
        setROperacionSinFiltro(planeacionesFromAPI);
        busquedaROperacion(planeacionesFromAPI, currentPage);
        setCargando(false);
    }


    //Obtiene los usuarios activos con permisos para autorizar no usar FIFO en planeación.
    async function fetchUsuario() {
        //Filtro por usuarios activos        
        let filter = {
            activo: {
                eq: true
            }
        }
        //Se obtienen los datos de los usuarios
        const apiData = await GetUsuarios(filter);
        //Se ordenan los datos por el campo orden
        const dataFromAPI = apiData.sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
        const usuarioLG = dataFromAPI.filter(usuarios => usuarios.usuario === userName);
        setDatosUsuario(usuarioLG[0] ? usuarioLG[0] : {});
    }


    function onSearchFechaPlaneacion(e) {
        setAVisible(false);
        window.scrollTo(0, 0);
        setCargando(true);
        setFechaPBusqueda(e.target.value);
        fetchROperacion(e.target.value ? e.target.value : rfechaini, e.target.value ? e.target.value : rfechafin);
    };
    function clicBuscarporFecha(e) {
        setAVisible(false);
        setBuscarporFecha(!buscarporFecha);
        if (!buscarporFecha === false) {
            if (fechaPBusqueda !== "") {
                setFechaPBusqueda("");
                fetchROperacion(rfechaini, rfechafin);
            }
        }
    };
    //Revisa cambios en la fecha de búsqueda
    function onChangesRFechaP(e) {
        e.persist()
        var fechaini = rfechaini;
        var fechafin = rfechafin;
        if (e.target.name === "Irfechaini") {
            fechaini = e.target.value;
        } else {
            fechafin = e.target.value;
        }
        setRfechafin(fechafin);
        setRfechaini(fechaini);
        fetchROperacion(fechaini, fechafin);
    }



    async function clicDescargarDatos() {
        try {
            setCargando(true);
            setAVisible(false);
            //Declaración de variables
            var DatosEXP = [];
            var planeacionesPD = rOperacion;
            //Se obtienen los datos en el orden requerido

            /* {
                 datoFROperacion.map((fila, i) => (
                     <Tr className={(i % 2) !== 0 ? "table-active" : ""} key={i}>
                         <Td>{fila.clave}</Td>
                         {fila.valores.map((valor, j) => (
                             ((j + 1) <= (currentPage * recordPerPage) &&
                                 (j + 1) > ((currentPage - 1) * recordPerPage)) && (
                                 <Td key={j}>{(i <= resumenO.length - 1 ? resumenO[i].signo === "$" ?
                                     resumenO[i].signo + (valor ? parseFloat(valor).toFixed(2) : "") :
                                     resumenO[i].signo === "%" ? (valor ? parseFloat(valor).toFixed(2) : "")
                                         + resumenO[i].signo : valor : (fila.clave === "Estatus de pendientes y mejoras" || fila.clave === "Acciones a tomar") ? valor :
                                     "$" + (valor ? parseFloat(valor).toFixed(2) : ""))}</Td>
                             )
                         ))}
                     </Tr>
                 ))
             }*/

            var campos = [];
            var fechas = [];

            //DatosEXP = [...datoFROperacion, ...encROPeracion]
            var worksheet = xlsx.utils.json_to_sheet(datoFROperacion);
            var workbook = xlsx.utils.book_new();
            xlsx.utils.book_append_sheet(workbook, worksheet, "ROP2025");
            xlsx.writeFile(
                workbook,
                "Resumen de operación " + Moment(Date()).format("YYYY-MM-DD HH:mm") + ".xlsx"
            );
            setCargando(false);
        } catch (error) {
            window.scrollTo(0, 0);
            setMensajeAlert(JSON.stringify(error.message));
            setColor("warning");
            setAVisible(true);
            setCargando(false);
            //setisDisabled(false);
        }
    }
    async function handleCallback(childData) {
        //setVarCP(childData);
        if (childData.completo === true) {
            setMensajeAlert(childData.mensaje);
        } else {
            if (childData.mensaje) {
                setMensajeAlert(childData.mensaje);
                setAVisible(true);

            }
        }

        fetchROperacion(rfechaini, rfechafin);
    };


    return (
        (vroperacion === true || edoperacion === true || eploperacion === true || eauoperacion === true || edeoperacion === true) && (
            <>
                <div className="conteiner2">
                    <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                        {mensajeAlert}
                    </Alert>
                    {(cargando === true) && (
                        <Row>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                <img width="150px" alt="cargando" src="assets/img/preloader.gif" />
                            </div>
                        </Row>
                    )}
                    {formType === "ResumenO" && (
                        <>
                            {(vroperacion === true || edoperacion === true || eploperacion === true || eauoperacion === true || edeoperacion === true) && (
                                <Row>
                                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px" >
                                        {/*  rOperacion.length > 0 &&*/ (<h5 className=" floatleft">Resumen de operación BTI </h5>)}
                                    </div>
                                    <div class="col-lg-2 col-md-6 col-sm-12 col-xs-12 text-left  margintop20px" >
                                        <FormGroup >
                                            <Label><h5>Búsqueda por fecha: </h5></Label>

                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <div class="input-group-text">
                                                        <input type="checkbox" checked={buscarporFecha} onChange={clicBuscarporFecha} />
                                                    </div>
                                                </div>
                                                <input type="date" class="form-control" onChange={onSearchFechaPlaneacion} value={fechaPBusqueda} disabled={!buscarporFecha} />
                                            </div>
                                        </FormGroup>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 margintop10px" >
                                        {vroperacion === true && (<button className="cbutton btn-warning floatright ml-2 " title="Descargar datos a excel" hidden={rOperacion.length ? false : true} onClick={() => { clicDescargarDatos("descarga"); }}>  <IoIcons.IoIosDownload /> Datos</button>)}
                                        {/*<button className="cbutton btn-info floatright ml-2 " title="Imprimir" hidden={rOperacion.length ? false : true} onClick={handlePrint}> Imprimir</button> */}
                                        <div className=" form-group row col-lg-12 col-md-12 col-sm-12 col-xs-12  floatrightleft ml-1">
                                            <div className="  col-lg-2 col-md-2 col-sm-12 col-xs-12  ml-3"></div>
                                            <div className=" form-group row col-lg-5 col-md-5 col-sm-12 col-xs-12   margintop10px   ml-1 ">
                                                <InputGroup>
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>Del:</InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input name="Irfechaini" type="date" value={Moment(rfechaini).format("YYYY-MM-DD")} onChange={onChangesRFechaP} />
                                                </InputGroup>
                                            </div>
                                            <div className=" form-group row col-lg-5 col-md-5 col-sm-12 col-xs-12   margintop10px  floatrightleft ml-1 ">
                                                <InputGroup className="floatrightleft ml-1">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>Al:</InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input name="Irfechafin" type="date" value={Moment(rfechafin).format("YYYY-MM-DD")} onChange={onChangesRFechaP} />
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </div>
                                </Row>)}
                            <div >
                                {(vroperacion === true || edoperacion === true || eploperacion === true || eauoperacion === true || edeoperacion === true) && (
                                    <button className="cbutton btn-dark floatright  marginrightmobil3p " title="Recargar página" onClick={() => { fetchROperacion(rfechaini, rfechafin); }}><IoIcons.IoMdRefresh /> Recargar </button>)}
                                {/*JSON.stringify(modificados.value.data.onUpdatePlaneacionBase)*/}
                                {(datoFROperacion.length > 0 && (
                                    <div className={((vroperacion === true || edoperacion === true || eploperacion === true || eauoperacion === true || edeoperacion === true) && rOperacion.length > 20) ? " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll wrapper displayNormal" :
                                        " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll displayNormal"}>

                                        <Table className=" mb-2  " >
                                            <Thead class="thead-secondary">
                                                <Tr>
                                                    <Td className="freez1C">Campo</Td>
                                                    {encROPeracion.map((rOperacion, i) => (
                                                        ((i + 1) <= (currentPage * recordPerPage) &&
                                                            (i + 1) > ((currentPage - 1) * recordPerPage)) && (
                                                            <Td className="">{rOperacion.fecha}
                                                                {((edoperacion === true || eploperacion === true || eauoperacion === true ||
                                                                    edeoperacion === true) && (i < 2) && encROPeracion.length > 0) && (
                                                                        <EditarRO
                                                                            dResumenO={rOperacion}
                                                                            bColor={"info  "}
                                                                            btitle={"Editar datos de Resumen de Operación"}
                                                                            modulo={"Métricas"}
                                                                            tipo={"CargaPintado"}
                                                                            usuario={datosUsuario}
                                                                            valorDeREtorno={handleCallback}
                                                                        />
                                                                    )}
                                                            </Td>
                                                        )
                                                    ))}

                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {datoFROperacion.map((fila, i) => (
                                                    <Tr className={(i % 2) !== 0 ? "table-active" : ""} key={i}>
                                                        <Td>{fila.clave/*resumenO[i].campo*/}</Td>
                                                        {fila.valores.map((valor, j) => (
                                                            ((j + 1) <= (currentPage * recordPerPage) &&
                                                                (j + 1) > ((currentPage - 1) * recordPerPage)) && (
                                                                <Td key={j}>{(i <= resumenO.length - 1 ? resumenO[i].signo === "$" ?
                                                                    resumenO[i].signo + (valor ? parseFloat(valor).toFixed(2) : "") :
                                                                    resumenO[i].signo === "%" ? (valor ? parseFloat(valor).toFixed(2) : "")
                                                                        + resumenO[i].signo : valor : (fila.clave === "Estatus de pendientes y mejoras" || fila.clave === "Acciones a tomar") ? valor :
                                                                    "$" + (valor ? parseFloat(valor).toFixed(2) : ""))}</Td>
                                                            )
                                                        ))}
                                                    </Tr>
                                                ))}
                                            </Tbody>
                                        </Table>
                                    </div>
                                ))}
                                {/*JSON.stringify(inventarioClientes)*/}
                                {rOperacion.length > 0 && (
                                    <div className={((vroperacion === true || edoperacion === true || eploperacion === true || eauoperacion === true || edeoperacion === true) && rOperacion.length > 20) ? " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll wrapper displayMobil" :
                                        " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll displayMobil"}>
                                        <Table className=" mb-2 scroll " >
                                            <Thead class="thead-secondary">
                                                <Tr>
                                                    {/*<Th className="minwidth100px">Pagina</Th>*/}

                                                    <Th class="minwidth60px">Editar</Th>
                                                    <Th className="minwidth100px">Fecha</Th>
                                                    <Th className="minwidth100px">Total Inspeccionado</Th>

                                                    <Th className="minwidth100px">Defectuoso BTI</Th>
                                                    <Th className="minwidth100px">% Defectuoso</Th>
                                                    <Th className="minwidth100px">1er contribuidor</Th>
                                                    <Th className="minwidth100px">1er contribuidor NP</Th>
                                                    <Th className="minwidth100px">2do Contribuidor</Th>
                                                    <Th className="minwidth100px">2do Contribuidor NP</Th>
                                                    <Th className="minwidth100px">3er Contribuidor</Th>
                                                    <Th className="minwidth100px">3er Contribuidor NP</Th>
                                                    <Th className="minwidth100px">SQFT Producidos</Th>
                                                    <Th className="minwidth100px">Gasto quimicos</Th>
                                                    <Th className="minwidth100px">Consumo de Agua</Th>
                                                    <Th className="minwidth100px">Costo Quimico SQFT</Th>
                                                    <Th className="minwidth100px">Costo Quimico vs Facturacion</Th>

                                                    <Th className="minwidth100px">Eficiencia de Carga de racks</Th>
                                                    <Th className="minwidth100px">Capacidad de Línea</Th>
                                                    <Th className="minwidth100px">Programados</Th>
                                                    <Th className="minwidth100px">Capacidad de Linea Programada</Th>
                                                    <Th className="minwidth100px">Cargados</Th>
                                                    <Th className="minwidth100px">Eficiencia de carga vs Plan de producción</Th>
                                                    <Th className="minwidth100px">Espacios vacios</Th>
                                                    <Th className="minwidth100px">% Perdido</Th>

                                                    <Th className="minwidth100px">Falta de personal de carga Ecoat</Th>
                                                    <Th className="minwidth100px">Incapacidad  de personal de Carga Ecoat</Th>
                                                    <Th className="minwidth100px">Falta de personal de Inspeccion Ecoat</Th>
                                                    <Th className="minwidth100px">Incapacidad de personal Inspeccion Ecoat</Th>

                                                    <Th className="minwidth100px">Falta de personal de carga Powder</Th>
                                                    <Th className="minwidth100px">Incapacidad  de personal de Carga Powder</Th>
                                                    <Th className="minwidth100px">Falta de personal de Inspeccion Powder</Th>
                                                    <Th className="minwidth100px">Incapacidad de personal Inspeccion Powder</Th>

                                                    <Th class="minwidth60px">Objetivo de facturacion 2025</Th>
                                                    <Th>Meta de Venta para cumplimiento KPI</Th>
                                                    <Th >Facturación planeada</Th>
                                                    <Th className="minwidth60px">Facturacion</Th>
                                                    <Th className="minwidth60px">Facturado pendiente por embarcar</Th>
                                                    <Th class="minwidth60px">Facturación total del día</Th>
                                                    <Th class="minwidth60px">Diferencia vs Planeado</Th>
                                                    <Th class="minwidth60px">Diferencia %</Th>
                                                    <Th class="minwidth60px">Material pendiente por inspeccion</Th>
                                                    <Th class="minwidth60px">Estatus de pendientes y mejoras</Th>
                                                    <Th class="minwidth60px">Acciones a tomar</Th>
                                                    <Th class="minwidth60px">Inventario</Th>
                                                    <Th class="minwidth60px">Inventario de clientes</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {rOperacion.map((rOperacionin, i) => (
                                                    ((i + 1) <= (currentPage * recordPerPage) &&
                                                        (i + 1) > ((currentPage - 1) * recordPerPage)) && (
                                                        <Tr >
                                                            <Td className={"margintopmobil20px"}>
                                                                {((edoperacion === true || eploperacion === true || eauoperacion === true ||
                                                                    (edeoperacion === true) && rOperacion.length > 0) && i < 2) && (
                                                                        <EditarRO
                                                                            dResumenO={rOperacionin}
                                                                            bColor={"info  "}
                                                                            btitle={"Editar datos de Resumen de Operación"}
                                                                            modulo={"Métricas"}
                                                                            tipo={"CargaPintado"}
                                                                            usuario={datosUsuario}
                                                                            valorDeREtorno={handleCallback}
                                                                        />
                                                                    )}
                                                            </Td>
                                                            <Td className={"margintopmobil20px"} >{rOperacionin.fecha}</Td>
                                                            <Td>{rOperacionin.totalInspeccionado}</Td>

                                                            <Td>{rOperacionin.defectuso}</Td>
                                                            <Td>{rOperacionin.porcentajeDefectuoso}</Td>
                                                            <Td>{rOperacionin.primerContribuidor}</Td>
                                                            <Td>{rOperacionin.primerContribuidorNP}</Td>
                                                            <Td>{rOperacionin.segundoContribuidor}</Td>
                                                            <Td>{rOperacionin.segundoContribuidorNP}</Td>
                                                            <Td>{rOperacionin.tercerContribuidor}</Td>
                                                            <Td>{rOperacionin.tercerContribuidorNP}</Td>
                                                            <Td>{rOperacionin.sqftProducidos}</Td>
                                                            <Td>{rOperacionin.gastosQuimicos}</Td>
                                                            <Td>{rOperacionin.consumoAgua}</Td>
                                                            <Td>{rOperacionin.costoQuimicoSQFT}</Td>
                                                            <Td>{rOperacionin.costoQuimicovsFacturacion}</Td>
                                                            <Td className={"margintopmobil20px"}>{rOperacionin.eficienciaCargaRacks} %</Td>
                                                            <Td className={"margintopmobil20px"}>{rOperacionin.ecCapacidadLinea}</Td>
                                                            <Td >{rOperacionin.ecProgramados}</Td>
                                                            <Td >{rOperacionin.ecCapacidadLineaProgramada} %</Td>
                                                            <Td className={"margintopmobil20px"} >{rOperacionin.ecCargados}</Td>
                                                            <Td>{rOperacionin.ecEFvsPP} %</Td>
                                                            <Td className={"margintopmobil20px"}  >{rOperacionin.ecEspaciosVacios}</Td>
                                                            <Td >{rOperacionin.ecPorcentajePerdido} %</Td>
                                                            <Td >{rOperacionin.apFaltaCarga} %</Td>
                                                            <Td className={"margintopmobil20px"} >{rOperacionin.apIncapacidadCarga} %</Td>
                                                            <Td className={"margintopmobil40px"}>{rOperacionin.apFaltaInspeccion} %</Td>
                                                            <Td className={"margintopmobil20px"}>{rOperacionin.apIncapacidadInspeccion} %</Td>

                                                            <Td className={"margintopmobil40px"} >{rOperacionin.apFaltaCargaPC} %</Td>
                                                            <Td className={"margintopmobil20px"} >{rOperacionin.apIncapacidadCargaPC} %</Td>
                                                            <Td className={"margintopmobil40px"}>{rOperacionin.apFaltaInspeccionPC} %</Td>
                                                            <Td className={"margintopmobil20px"}>{rOperacionin.apIncapacidadInspeccionPC} %</Td>

                                                            <Td className={"margintopmobil40px"}  >{rOperacionin.objetivoFacturacion}</Td>
                                                            <Td className={"margintopmobil20px"}  >{rOperacionin.metaVentaCumplimientoKPI}</Td>
                                                            <Td className={"margintopmobil20px"}  >${rOperacionin.facturacionPlaneada}</Td>
                                                            <Td >
                                                                ${rOperacionin.facturacion}
                                                            </Td>
                                                            <Td >${rOperacionin.facturadoPendientePorEmbarcar}</Td>
                                                            {/*<Td >{rOperacionin.materialEnCantidad}</Td>*/}
                                                            <Td className={"margintopmobil20px"}>${rOperacionin.facturacionTotaldelDia}</Td>
                                                            <Td className={"margintopmobil20px"}>${rOperacionin.diferenciaVSPlaneado}</Td>
                                                            <Td className={"margintopmobil20px"}>{rOperacionin.diferenciaPorcentaje} %</Td>
                                                            <Td >${rOperacionin.materialPendienteporInspeccion}</Td>
                                                            <Td className={"margintopmobil20px"}>{rOperacionin.estatusPendientesMejoras}</Td>
                                                            <Td className={"margintopmobil20px"}>{rOperacionin.accionesaTomar}</Td>
                                                            {<Td >${rOperacionin.inventario}</Td>}
                                                            <Td className={""}></Td>
                                                            {dInventarioC.map((inventarioC, i) => (
                                                                rOperacionin.fecha === inventarioC.fecha && (
                                                                    <Td className="">{inventarioC.cliente + " $" + (inventarioC.total ? inventarioC.total.toFixed(2) : "--")}
                                                                    </Td>
                                                                )
                                                            ))}
                                                        </Tr>
                                                    )
                                                ))}
                                            </Tbody>
                                        </Table>
                                    </div>
                                )}
                                {rOperacion.length > 0 && (
                                    <Row>
                                        <div className="col-lg-12 col-md-12 col-sm-12  ">
                                            <div className="floatcenter">
                                                <Pagination
                                                    itemClass="page-item" // add it for bootstrap 4
                                                    linkClass="page-link" // add it for bootstrap 4
                                                    activePage={currentPage}
                                                    itemsCountPerPage={recordPerPage}
                                                    totalItemsCount={totalRecords}
                                                    pageRangeDisplayed={pageRange}
                                                    onChange={handlePageChange}
                                                />
                                            </div>
                                        </div>
                                    </Row>
                                )}
                            </div>
                        </>

                    )}

                </div>
            </>
        )
    )
};



export default ResumenOperacion